import { Engine, Mesh, MeshBuilder, SceneOptions, StandardMaterial, Vector3 } from '@babylonjs/core';
import { ICamera } from 'Framework/Components/Controls/XView/Cameras';
import { IFlatConfiguration } from 'Framework/Components/Controls/XView/Core';
import { TextureMaterial } from 'Framework/Components/Controls/XView/Materials';
import { BaseRenderer } from 'Framework/Components/Controls/XView/Renderers/BaseRenderer';

export class Flat2DRenderer extends BaseRenderer<IFlatConfiguration> {
    public constructor(engine: Engine, camera: ICamera, options?: SceneOptions) {
        super(engine, camera, options);
    }

    protected override onLoad(configuration: IFlatConfiguration): void {
        this.camera.lookTo(configuration.startPosition);

        const ratio = this._configuration.ratio;

        this._plane = MeshBuilder.CreatePlane('plane', { width: 1, height: 1 / ratio }, this);
        this._plane.parent = this.getTransformNodeByName('root');
        this._plane.position = new Vector3(0.5, 0.5 / ratio, 0);
        let material: StandardMaterial = new TextureMaterial('material_2D_Plane', this, this._configuration.url);

        this._plane.material = material;
    }

    public fitWidth(): this {
        this._internalFit();

        return this;
    }

    public fitHeight(): this {
        const engine = this.getEngine();

        const containerRatio = engine.getRenderWidth() / engine.getRenderHeight();

        this._internalFit(containerRatio / this._configuration.ratio);

        return this;
    }

    public fit(): this {
        const engine = this.getEngine();

        const imageRatio = this._configuration.ratio;
        const containerRatio = engine.getRenderWidth() / engine.getRenderHeight();

        if (imageRatio > containerRatio) {
            //Fit width
            this._internalFit();
        }
        else {
            //Fit height
            this._internalFit(containerRatio / imageRatio);
        }

        return this;
    }

    public center(): this {
        this.camera.lookTo(this._plane.position);

        return this;
    }

    /**
     *  Adjusts the camera's field of view (FOV) based on a given scale.
     * @param scale Scale of the image (1 = 100%) of the image width.
     * If you want to adjust to a specific width, the Scale is the desired width.
     * If you want to adjust to a specific height, the Scale is the desired height multiplied by the camera's aspect ratio.
     */
    private _internalFit(scale: number = 1): void {
        this.camera.fov = 2 * Math.atan(scale);
    }

    private _plane: Mesh;
}
